var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',{staticClass:"header-container"},[_c('header-bar')],1),_vm._v(" "),_c('el-container',[_c('el-aside',{staticClass:"left-container"},[_c('el-scrollbar',{staticClass:"left-scrollbar"},[_c('nav-menu',{attrs:{"menu":_vm.menu}})],1)],1),_vm._v(" "),_c('el-main',{staticClass:"main-container"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c4cf7b3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/index.vue
// module id = null
// module chunks = 